// WARNING: This file is auto-generated. Do not modify.
import React, { SVGProps } from 'react';

const Menu = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path d="M22.083 7H1.917C1.413 7 1 6.55 1 6s.413-1 .917-1h20.166c.505 0 .917.45.917 1s-.413 1-.917 1zm0 6H1.917C1.413 13 1 12.55 1 12s.413-1 .917-1h20.166c.505 0 .917.45.917 1s-.413 1-.917 1zm0 6H1.917C1.413 19 1 18.55 1 18s.413-1 .917-1h20.166c.505 0 .917.45.917 1s-.413 1-.917 1z" />
  </svg>
);

export default Menu;
